import React, {FC} from 'react';

import Box from '@mui/material/Box';
import IsoLogo from '@/components/logos/IsoLogo';
import Typography from '@mui/material/Typography';
import MobileOffIcon from '@mui/icons-material/MobileOff';
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';

import {useTranslation} from 'react-i18next';
import {keyframes} from '@mui/system';
import {useMediaQuery, useTheme} from '@mui/material';

const UnsupportedDevice: FC = () => {

  const theme = useTheme();
  const {t} = useTranslation();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const isTabletPortrait = isPortrait && !isMobile;

  if(!isMobile && !isTabletPortrait) return;

  const rotateLeft = keyframes`
  0% { transform: rotate(45deg); }
  50% { transform: rotate(-45deg); }
  100% { transform: rotate(45deg); }
`;
  
  const styles = {
    container: {
      bgcolor: 'primary.main',
      height: '100vh',
      width: '100vw',
      display: 'flex', 
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      zIndex: 7000
    },
    messagge: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    icon: {
      color: 'common.white',
      fontSize: '96px'
    },
    iconAnimation: {
      animation: `${rotateLeft} 4s infinite`,
      display: 'inline-block'
    },
    text: {
      color: 'common.white',
      m: 4,
      textAlign: 'center',
      px: 2
    },
    logo: {
      position: 'absolute',
      bottom: 8,
      left: 8
    }
  };
  
  return <Box sx={styles.container}>
    {
      isMobile && 
      <Box sx={styles.messagge}>
        <MobileOffIcon sx={styles.icon}/>
        <Typography variant="h4" sx={styles.text}>{t('responsive.mobileUnavailable')}</Typography>
      </Box>
    }
    {
      isTabletPortrait &&
      <Box sx={styles.messagge}>
        <ScreenRotationIcon sx={{...styles.icon, ...styles.iconAnimation}}/>
        <Typography variant="h4" sx={styles.text}>{t('responsive.orientationUnavailable')}</Typography>
      </Box>
    }
    <Box sx={styles.logo}>
      <IsoLogo width={isMobile ? '40vw' : '20vw'}/>
    </Box>
  </Box>;
};
export default UnsupportedDevice;

